import { apiJson, replaceUserEndpoint } from './userEndpoint';
import { replaceFitnessProfileEndpoint } from './fitnessProfileBloodPressure';

export function replaceFitnessProfileGoalEndpoint(template, { userId, fitnessProfileId, goalId }) {
	return replaceUserEndpoint(template, { userId, fitnessProfileId, id: goalId });
}

export async function createFitnessProfileGoals({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	goals
}) {
	const url = replaceFitnessProfileEndpoint(endpoint, { userId, fitnessProfileId });
	const data = await apiJson(url, {
		method: 'POST',
		csrfToken,
		body: { goals }
	});
	return data.data;
}

export async function bulkUpdateFitnessProfileGoals({
	userId,
	fitnessProfileId,
	endpoint,
	csrfToken,
	goals
}) {
	const url = replaceFitnessProfileEndpoint(endpoint, { userId, fitnessProfileId });
	const data = await apiJson(url, {
		method: 'PATCH',
		csrfToken,
		body: { goals }
	});
	return data.data;
}

export async function updateFitnessProfileGoal({
	userId,
	fitnessProfileId,
	goalId,
	endpoint,
	csrfToken,
	goal
}) {
	const url = replaceFitnessProfileGoalEndpoint(endpoint, { userId, fitnessProfileId, goalId });
	const data = await apiJson(url, {
		method: 'PATCH',
		csrfToken,
		body: { goal }
	});
	return data.data;
}

export async function deleteFitnessProfileGoal({
	userId,
	fitnessProfileId,
	goalId,
	endpoint,
	csrfToken
}) {
	const url = replaceFitnessProfileGoalEndpoint(endpoint, { userId, fitnessProfileId, goalId });
	const data = await apiJson(url, {
		method: 'DELETE',
		csrfToken
	});
	return data.data;
}

export async function updateFitnessProfileGoalProgress({
	userId,
	fitnessProfileId,
	goalId,
	endpoint,
	csrfToken,
	manualProgressPercent
}) {
	const url = replaceFitnessProfileGoalEndpoint(endpoint, { userId, fitnessProfileId, goalId });
	const data = await apiJson(url, {
		method: 'PATCH',
		csrfToken,
		body: { goal_progress: { manual_progress_percent: manualProgressPercent } }
	});
	return data.data;
}
